import { Anchor, Box, Group, Text, ThemeIcon } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import dayjs from 'dayjs';

import { WindowStatusEnum } from '@/api';

import type { WindowStatus } from '../types';
import { SUPPORT_PORTAL_AVAILABILITY_HREF } from '@/constants';

type DeadlineBannerProps = {
  deadlineDate: string | null;
  windowStatus: WindowStatus;
  requiresSubmission: boolean;
};

const DeadlineBanner: React.FC<DeadlineBannerProps> = ({
  deadlineDate,
  windowStatus,
  requiresSubmission,
}) => {
  if (windowStatus === WindowStatusEnum.LOCKED) {
    return (
      <Group justify="center" align="flex-start" gap={8}>
        <ThemeIcon size={18} variant="white" c="grey">
          <IconInfoCircle />
        </ThemeIcon>
        <Box ta="center">
          <Text fz="xs">To make adjustments after submission please contact</Text>
          <Anchor
            href={SUPPORT_PORTAL_AVAILABILITY_HREF}
            size="xs"
            target="_blank"
            rel="noopener noreferrer"
          >
            your local Fooda Client Success Team.
          </Anchor>
        </Box>
      </Group>
    );
  }

  if (deadlineDate && requiresSubmission && windowStatus === WindowStatusEnum.OPEN) {
    const formattedDate = dayjs(deadlineDate).format('D MMM');
    return (
      <Text ta="center" fz="xs">
        Update until {formattedDate}. You can edit before the cutoff.
      </Text>
    );
  }

  if (!requiresSubmission && windowStatus === WindowStatusEnum.OPEN) {
    return (
      <Text ta="center" fz="xs">
        Only update if something changes.
      </Text>
    );
  }

  return null;
};

export default DeadlineBanner;
